import ReceiptLayout from '@/components/MedicalReceipt/ReceiptLayout';
import { IMG_CASH_PICKUP_GUIDE_MAIN } from '@repo/assets';
import styled from 'styled-components';
import { CashPickupIntroBox } from '@repo/components';
import { useEffect } from 'react';
import TextButton from '@/components/common/TextButton';
import { useHistory } from 'react-router';
import { routes } from '@/constant/routes.const';
import {
  CASH_PICKUP_STORE_INTRO_BOXES,
  CASH_PICKUP_STORE_INTRO_BOXES_FORCE,
} from '@/constant/cashPickUp.const';
import { useAppSelector } from '@/hooks/useReduxHooks';
import { IGlobalState } from '@/store';

export default function MedicalCashPickupIntro() {
  const { isUploadRequired } = useAppSelector((state) => state) as IGlobalState;
  const history = useHistory();
  useEffect(() => {
    const handleBackButton = () => {
      window.history.go(1);
    };
    window.addEventListener('popstate', handleBackButton);
    return () => window.removeEventListener('popstate', handleBackButton);
  }, []);

  const handleNavigateHome = () => {
    history.replace(routes.medicalHome);
  };

  return (
    <ReceiptLayout hasPadding={false}>
      <MainImage
        src={IMG_CASH_PICKUP_GUIDE_MAIN}
        alt='CashPickupGuideMainImage'
      />
      <InnerWrapper>
        <Title>
          Receive Your Cash Directly at Western Union Without a Bank Account
        </Title>
        <BoxWrapper>
          {isUploadRequired &&
            CASH_PICKUP_STORE_INTRO_BOXES_FORCE.map((box) => (
              <CashPickupIntroBox key={box.index} {...box} />
            ))}
          {!isUploadRequired &&
            CASH_PICKUP_STORE_INTRO_BOXES.map((box) => (
              <CashPickupIntroBox key={box.index} {...box} />
            ))}
        </BoxWrapper>
        <BtnWrapper>
          <TextButton
            title='Go to get Tax Refund'
            onClick={handleNavigateHome}
          />
        </BtnWrapper>
      </InnerWrapper>
    </ReceiptLayout>
  );
}

const Title = styled.h1`
  color: var(--KTP-Grayscale-Gray_02, #111);
  font-size: 24px;
  font-weight: 700;
  line-height: 150%; /* 36px */
  letter-spacing: -0.48px;
`;

const MainImage = styled.img`
  width: 100%;
  height: auto;
`;

const InnerWrapper = styled.div`
  padding: 40px 20px;
  display: flex;
  flex-direction: column;
  gap: 40px;
`;

const BoxWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 60px;
`;

const BtnWrapper = styled.div``;
